// The backend error envelope flags whether ErrorMessage was written for the operator. Without the flag
// the message is a per-endpoint fallback the controller passes for any unclassified failure ("Unexpected
// error while completing Vessel Job") — never something to show.
const hasHumanErrorMessage = (response: unknown): boolean =>
  typeof response === 'object' &&
  response !== null &&
  'IsHumanErrorMessage' in response &&
  response.IsHumanErrorMessage === true;

export class ApiError<TResponse = unknown> extends Error {
  public readonly status: number;
  public readonly response: TResponse | undefined;
  /** True when `message` came from the backend as operator-facing text and may be displayed as-is. */
  public readonly isHumanMessage: boolean;

  // status = 0 means no HTTP response (network error, timeout, CORS)
  constructor(message: string, status = 0, response?: TResponse) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.response = response;
    this.isHumanMessage = hasHumanErrorMessage(response);
  }
}
